import { Select, MenuItem, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { logoutUser } from 'src/auth/auth0';
import { selectUserName } from 'src/store/slices/user-slice';

import { styles } from './styles';

export const LogoutDropdown = () => {
    const { t } = useTranslation();
    const userName = useSelector(selectUserName);
    const title = (
        <Typography variant="h4" css={styles.nameText}>
            {`${t('header_greeting')} ${userName}`}
        </Typography>
    );

    const handleLogoutClick = () => {
        logoutUser();
    };

    return (
        <Select
            value={title}
            onChange={handleLogoutClick}
            variant="standard"
            disableUnderline
            IconComponent={() => null}
            renderValue={() => title}
            MenuProps={{
                sx: styles.menuList,
            }}
            css={styles.container}
        >
            <MenuItem css={styles.menuItem} onClick={handleLogoutClick}>
                <Typography variant="subtitle3">{t('header_logout')}</Typography>
            </MenuItem>
        </Select>
    );
};
